import { useClients } from 'src/clients/hooks/useClients';
import { useFamily } from 'src/clients/hooks/useFamily';

export const useFamilySurname = (familyId?: string): string | null => {
  const { family } = useFamily(familyId);
  const { clients } = useClients({ familyId }, { enabled: !!familyId });

  const mainClientId = family?.mainFamilyMember.clientId;
  const mainMember = clients.find(client => client.id === mainClientId);

  return mainMember?.lastName ?? null;
};
